<div class="display-only">
  <div class="label">{{ label }}</div>
  <div class="value" [class.uppercase]="uppercase" [class.empty]="empty$ | async">{{ text$ | async }}</div>
</div>
